import React from "react";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { Menu, ClickAwayListener } from "@material-ui/core";
import { MyMenuItem } from "../../styling/Styles";

/**
 * @param {boolean} props.enableBreadCrumb - shows if onclick functions in breadcrumb are enabled/disabled   
 * @param {setState} props.setAboutToViewFrontQuality - hook method that updates aboutToViewFrontQuality, this variable is used inside BuildUpsExitPopUpWindow pop up to navigate to front_project_quality
 * @param {setState} props.setAboutToViewServerQuality - hook method that updates aboutToViewProjectFlow, this variable is used inside BuildUpsExitPopUpWindow pop up το navigate to server_project_quality 
 * @param {boolean} props.needSave - shows if current project is saved/unsaved 
 * @param {method} props.savedPageClicked - method that saves project's page
 * @param {setState} props.setAlertExitBuildUps - hook method that updates alertExitBuildUps, this variable opens/close BuildUpsExitPopUpWindow pop up
 * @returns component with a dropdown menu that opens options to nagiate to view  page's 'data flow' and view project's 'data flow' 
 */
const ViewProjectQuality = (props) => {
  const {
    enableBreadCrumb,
    setAboutToViewFrontQuality,
    setAboutToViewServerQuality,
    needSave,
    savedPageClicked,
    setAlertExitBuildUps,
  } = props;

  const qualityOptions = [
    "Quality of backend code",
    "Quality of frontend code",
  ];
  const [anchorEl, setAnchorEl] = React.useState(); // anchor element of dropdown component
  const [stateQualityOptions, setStateQualityOptions] = React.useState(false); // opens/closes dropdown menu 
  const [hoverState, setHoverState] = React.useState(false); // hover state of project quality icon
  const navigate = useNavigate(); // initalize navigation

  // closes dropdown menu
  const closeDisplayQualityOptions = () => {
    setStateQualityOptions(false);
    setAnchorEl(null);
  };

  // Method that is called when 'Quality of backend code' option is pressed
  const changeToServerQualityPage = () => {
    // If page is unsaved and setAboutToViewServerQuality is given as property then BuildUpsExitPopUpWindow pop up opens and aboutToViewServerQuality variable is set to true
    if (setAboutToViewServerQuality !== undefined && needSave() === true) {
      setAboutToViewServerQuality(true);
      setAlertExitBuildUps(true);
    } 
    // setAboutToViewServerQuality is not given as attribute. This happens in every page that uses this component except inside build_apps
    else {
      // save before leaving page. This may needs to removed 
      if (setAboutToViewServerQuality !== undefined) {
        savedPageClicked();
      }
      navigate("/server_project_quality", { state: { reason: "server" } }); // navigate to page server_project_quality
    }
  };

  // Method that is called when 'Quality of frontend code' option is pressed
  const changeToFrontQualityPage = () => {
    // If page is unsaved and setAboutToViewFrontQuality is given as property then BuildUpsExitPopUpWindow pop up opens and aboutToViewFrontQuality variable is set to true
    if (setAboutToViewFrontQuality !== undefined && needSave() === true) {
      setAboutToViewFrontQuality(true);
      setAlertExitBuildUps(true);
    } 
    // setAboutToViewFrontQuality is not given as attribute. This happens in every page that uses this component except inside build_apps
    else {
      // save before leaving page. This may needs to removed 
      if (setAboutToViewFrontQuality !== undefined) {
        savedPageClicked();
      }
      navigate("/front_project_quality", { state: { reason: "front" } }); // navigate to page front_project_quality
    }
  };

  // This method is called when option of dropdown menu is pressed
  const selectQualityOption = (index) => {
    if (index === 0) {
      changeToServerQualityPage();
    } else if (index === 1) {
      changeToFrontQualityPage();
    }
  };

  // open dropdown menu
  const openProjectQualityOptions = (event) => {
    setAnchorEl(event.currentTarget);
    setStateQualityOptions(true);
  };

  return (
      enableBreadCrumb === false ? (
        <div
          style={{
            marginRight: "1vw",
            marginTop: "0.5vw",
            transform: "translate(-50%, 0)",
          }}
        >
          <img style={{ width: "1.8vw" }} alt='qualityIcon' src='/images/General/Quality_icon.png'/>
        </div>
      ) : (
        <div
          className={clsx("teamSelector")}
          data-tooltip="View project quality"
          data-tooltip-pos="bottom"
          style={{ marginRight: "1vw", marginTop: "0.5vw" }}
          onMouseOver={() => setHoverState(true)}
          onMouseOut={() => setHoverState(false)}
          onFocus={() => {}}
          onBlur={() => {}}
          onClick={(event) => openProjectQualityOptions(event)}
          aria-hidden="true"
        >
          {hoverState === false ? (
            <img style={{ width: "1.8vw" }} alt='quality' src='/images/General/Quality_icon.png' />
          ) : (
            <img src='/images/General/Quality_icon_hover.png' alt='qualityHover' style={{ width: "1.8vw" }} />
          )}
          {stateQualityOptions === false ? (
            <span />
          ) : (
            <ClickAwayListener onClickAway={closeDisplayQualityOptions}>
              <span />
            </ClickAwayListener>
          )}
          <Menu
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            anchorEl={anchorEl}
            keepMounted
            open={stateQualityOptions}
            MenuListProps={{ onMouseLeave: closeDisplayQualityOptions }}
          >
            {qualityOptions.map((option, index) => (
              <MyMenuItem
                key={option}
                onClick={() => selectQualityOption(index)}
              >
                {option}
              </MyMenuItem>
            ))}
          </Menu>
        </div>
      )
  );
};

export default ViewProjectQuality;
